import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { NgxLoadingModule } from 'ngx-loading';
import { AdminService } from '../../admin/admin.service';
// import { JsonPipe } from '@angular/common';
import { ManageFiltersService } from '../../services/manage-filters.service';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
  selector: 'app-edit-auto-reports-modal',
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    NgxLoadingModule,
    KENDO_GRID,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    // JsonPipe,
  ],
  templateUrl: './edit-auto-reports-modal.component.html',
  styleUrl: './edit-auto-reports-modal.component.scss',
})
export class EditAutoReportsModalComponent implements OnInit {
  private ss = inject(SessionStorageService);
  private manageFilterService = inject(ManageFiltersService);
  dialogRef = inject<MatDialogRef<EditAutoReportsModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  SUPPORTED_GRIDS = ['RepBehavior', 'CaseExplorer'];

  // various mappings for any key-value pairs for mat-select
  gridNameValueToLabelMap: { [key: string]: string } = {
    RepBehavior: 'Rep Behavior',
    CaseExplorer: 'Case Explorer',
  };
  filterGroupValueToLabelMap: { [key: number]: string } = {
    0: 'User Filters',
    1: 'Manager Filters',
    2: 'Filters Shared With You',
  };
  cadenceValueToLabelMap: { [key: string]: string } = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
  };
  weekdayValueToLabelMap: { [key: number]: string } = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  };
  cadenceTypes = ['Daily', 'Weekly', 'Monthly'];
  daysOfWeek = Array.from({ length: 7 }, (_, i) => i); // 0 to 6
  daysOfMonth = Array.from({ length: 31 }, (_, i) => i + 1); // 1 to 31
  selectedCadence: string | null = null;
  selectedDayOfWeek: number | null = null;
  selectedDayOfMonth: number | null = null;
  showMonthlyWarning = false;
  filterName = null;
  confirmCheck = null;
  gridName = null;
  title = null;
  description = null;
  filterNameStatic = null;
  editItem;
  lockGridName = false;
  allFilterData: {
    User?: [{ Grid: string }];
    Manager?: [
      {
        RootUnitID(RootUnitID: any): unknown;
        Grid: string;
      },
    ];
    Global?: [{ Grid: string }];
  };
  availableGridNames = [];
  savedUserFilters: { Grid: string }[];
  managedUnits: any[];
  savedManagerFilters: any[];
  savedGlobalFilters: { Grid: string }[];
  savedFilters: any[];
  filterID: any;
  currentSelectedSavedFilter: any;
  loading: boolean;
  filterGroups: number[] = [];
  globals: any;

  constructor() {
    this.editItem = this.data.dataItem;
  }
  ngOnInit(): void {
    this.globals = this.ss.get('globals');
    if (this.data.dataItem) {
      this.lockGridName = true;
      this.title = this.data.dataItem.reportName;
      this.description = this.data.dataItem.reportDescription;
      this.gridName = this.data.dataItem.grid;
      this.filterNameStatic = this.data.dataItem.Name;
      this.selectedCadence = this.data.dataItem.cadenceType;
      if (this.selectedCadence === 'Weekly') {
        this.selectedDayOfWeek = +this.data.dataItem.cadenceValue;
      } else if (this.selectedCadence === 'Monthly') {
        this.selectedDayOfMonth = +this.data.dataItem.cadenceValue;
      }
      this.availableGridNames = [this.data.dataItem.grid];
    }
    this.manageFilterService.getSavedFilterTemplates().subscribe(res => {
      this.allFilterData = res;
      if (!this.data.dataItem) {
        this.getGridNames();
        this.formatFilterData();
      }
    });
  }
  getGridNames() {
    this.allFilterData.User.forEach(filterItem => {
      if (
        !this.availableGridNames.includes(filterItem.Grid) &&
        this.SUPPORTED_GRIDS.includes(filterItem.Grid)
      ) {
        this.availableGridNames.push(filterItem.Grid);
      }
    });
    this.allFilterData.Manager.forEach(filterItem => {
      if (
        !this.availableGridNames.includes(filterItem.Grid) &&
        this.SUPPORTED_GRIDS.includes(filterItem.Grid)
      ) {
        this.availableGridNames.push(filterItem.Grid);
      }
    });
    this.allFilterData.Global.forEach(filterItem => {
      if (
        !this.availableGridNames.includes(filterItem.Grid) &&
        this.SUPPORTED_GRIDS.includes(filterItem.Grid)
      ) {
        this.availableGridNames.push(filterItem.Grid);
      }
    });
  }
  getGridNameLabel(option: string): string {
    return this.gridNameValueToLabelMap[option] || 'Unknown Label';
  }
  getGroupLabel(group: number): string {
    return this.filterGroupValueToLabelMap[group] || 'Unknown Label';
  }
  getCadenceLabel(cadence: string): string {
    return this.cadenceValueToLabelMap[cadence] || 'Unknown Label';
  }
  getWeekdayLabel(weekday: number): string {
    return this.weekdayValueToLabelMap[weekday] || 'Unknown Label';
  }
  formatFilterData() {
    let respManagerUnits = [];
    if (this.allFilterData && this.allFilterData['User']) {
      this.savedUserFilters = this.allFilterData['User'].filter(filter =>
        this.SUPPORTED_GRIDS.includes(filter.Grid)
      );
    }
    if (this.allFilterData && this.allFilterData['Manager']) {
      this.managedUnits = [];
      this.savedManagerFilters = [];
      respManagerUnits = this.allFilterData['Manager'].filter(filter => {
        if (this.SUPPORTED_GRIDS.includes(filter.Grid)) {
          if (!this.managedUnits.includes(filter.RootUnitID)) {
            this.managedUnits.push(filter.RootUnitID);
          }
        }
        return filter;
      });
      this.managedUnits.forEach(unit => {
        this.savedManagerFilters.push({
          unit: unit,
          filters: respManagerUnits.filter(filter => {
            return (
              filter.RootUnitID === unit &&
              this.SUPPORTED_GRIDS.includes(filter.Grid)
            );
          }),
        });
      });
    }
    if (this.allFilterData && this.allFilterData['Global']) {
      this.savedGlobalFilters = this.allFilterData['Global'].filter(filter =>
        this.SUPPORTED_GRIDS.includes(filter.Grid)
      );
    }
    this.savedFilters = [
      ...this.savedUserFilters,
      ...respManagerUnits,
      ...this.savedGlobalFilters,
    ];
    if (this.filterID) {
      this.savedFilters.forEach(filter => {
        if (filter.FilterID === +this.filterID) {
          this.currentSelectedSavedFilter = filter;
        }
      });
    }
  }
  onCadenceChange(): void {
    this.selectedDayOfWeek = null;
    this.selectedDayOfMonth = null;
    this.showMonthlyWarning = false;
  }

  onDayOfMonthChange(): void {
    this.showMonthlyWarning =
      this.selectedDayOfMonth === 30 || this.selectedDayOfMonth === 31;
  }

  submitData(): void {
    let cadenceValue = 0;
    if (this.selectedCadence === 'Weekly') {
      cadenceValue = +this.selectedDayOfWeek;
    }
    if (this.selectedCadence === 'Monthly') {
      cadenceValue = +this.selectedDayOfMonth;
    }
    const payloadOut = {
      reportName: this.title,
      reportDescription: this.description,
      grid: this.gridName,
      userId: this.globals.user.id,
      cadenceType: this.selectedCadence,
      cadenceValue: cadenceValue,
    };
    if (!this.data.dataItem) {
      payloadOut['filterId'] = this.filterName;
    } else {
      payloadOut['id'] = this.data.dataItem.id;
    }

    this.dialogRef.close(payloadOut);
  }

  gridNameChange(ev): void {
    this.filterName = null;
    this.filterGroups = [];
    this.savedFilters.forEach(filterItem => {
      if (
        filterItem.Grid === this.gridName &&
        !this.filterGroups.includes(filterItem.Scope)
      ) {
        this.filterGroups.push(filterItem.Scope);
      }
    });
  }

  checkFields(): boolean {
    if (
      this.title &&
      this.description &&
      this.gridName &&
      (this.filterName || this.filterNameStatic) &&
      (this.selectedCadence === 'Daily' ||
        ((this.selectedCadence === 'Weekly' ||
          this.selectedCadence === 'Monthly') &&
          (typeof this.selectedDayOfWeek === 'number' ||
            typeof this.selectedDayOfMonth === 'number'))) &&
      this.confirmCheck
    ) {
      return false;
    }

    return true;
  }

  getMonthlySuffix(day: number): string {
    if (day >= 11 && day <= 13) {
      return `${day}th`; // Special case for 11th, 12th, 13th
    }

    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }
}
